import {Outlet} from "react-router-dom";
import OrderLogContext from "../context/AdminDashboard/OrderLogContext";
import OrderLog from "../pages/AdminDashboard/OrderLog";
import OrderContext from "../context/AdminDashboard/OrderContext";
import Order from "../pages/AdminDashboard/Order";
import OrderAddContext from "../context/AdminDashboard/OrderAddContext";
import AddOrder from "../pages/AdminDashboard/OrderAdd";
import React from "react";

export const orderRoutes = {
    path: "order",
    element: <Outlet/>,
    children: [
        {
            path: "log",
            element: (
                <OrderLogContext>
                    <OrderLog/>
                </OrderLogContext>
            )
        },
        {
            path: "order",
            element: (
                <OrderContext>
                    <Order/>
                </OrderContext>
            )
        },
        {
            path: "add",
            element: (
                <OrderAddContext>
                    <AddOrder/>
                </OrderAddContext>
            )
        },
    ]


}